export default __webpack_public_path__ + "static/media/do.376e049e.JPG";